module.exports = __webpack_public_path__ + "img/emo_34.fdd258c6.png";